var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 0C15.7406 0 13.6875 2.05312 13.6875 4.5625V68.4375C13.6875 70.9469 15.7406 73 18.25 73H63.875C66.3844 73 68.4375 70.9469 68.4375 68.4375V18.25L50.1875 0H18.25Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.75 18.25H68.4375L50.1875 0V13.6875C50.1875 16.1969 52.2406 18.25 54.75 18.25Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4375 31.9375L54.75 18.25H68.4375V31.9375Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3125 59.3125C59.3125 60.5672 58.2859 61.5938 57.0312 61.5938H6.84375C5.58906 61.5938 4.5625 60.5672 4.5625 59.3125V36.5C4.5625 35.2453 5.58906 34.2188 6.84375 34.2188H57.0312C58.2859 34.2188 59.3125 35.2453 59.3125 36.5V59.3125Z",
    fill: "#84BD5A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2111 45.3149C27.6308 41.7767 32.9735 41.1402 35.492 43.0747C36.733 44.0762 35.419 45.6639 34.324 44.8609C32.9735 44.0032 29.9098 43.6017 29.5265 45.4974C29.0338 48.4904 36.968 46.7772 36.8425 51.6271C36.7148 56.2603 30.001 56.3698 27.4825 54.2893C26.8803 53.7988 26.8985 52.9981 27.227 52.5031C27.7015 52.0309 28.2308 51.8666 28.8513 52.3753C30.3455 53.3973 34.1963 54.1639 34.4677 51.5701C34.2328 48.8736 26.6453 50.4979 27.2111 45.3149Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2232 54.3828L38.4074 44.2951C37.6957 42.8533 39.8492 41.6694 40.6499 43.1818L42.2742 46.8478L44.3706 51.6635L46.4306 46.8478L48.0548 43.1818C48.7848 41.7971 50.8996 42.6708 50.2813 44.1856L45.6299 54.3828C45.2101 55.5325 43.9167 55.804 43.2232 54.3828Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9165 48.3464C13.9165 44.8265 16.1225 41.8015 20.32 41.8015C21.9054 41.8015 23.1647 42.2737 24.4969 43.4235C24.9897 43.8775 25.0422 44.6827 24.5494 45.1915C24.0567 45.6272 23.3084 45.5747 22.8727 45.139C22.1244 44.3542 21.3579 44.1375 20.32 44.1375C17.5118 44.1375 16.1613 46.1245 16.1613 48.3487C16.1613 50.6117 17.4912 52.6922 20.32 52.6922C21.3579 52.6922 22.3252 52.2702 23.1647 51.5242C23.7304 51.0862 24.5152 51.3029 24.8414 51.7432C25.1334 52.1447 25.2794 52.8177 24.6407 53.4564C23.3632 54.645 21.8324 54.8799 20.3177 54.8799C15.9058 54.8799 13.9165 51.8687 13.9165 48.3464Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0312 61.5938H13.6875V63.875H57.0312C58.2859 63.875 59.3125 62.8484 59.3125 61.5938V59.3125C59.3125 60.5672 58.2859 61.5938 57.0312 61.5938Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.07259d3404fc94ac6d509b374f0edbf2.svg";
export { ForwardRef as ReactComponent };